<template>
    <div class="tab-item-container">
      <div
        class="item"
        v-for="item in data"
        :key="item.id"
        @click="showDetailItem(item)"
      >
        <div
          v-if="item.data_type == 'ugc_item' && item.type === 6"
          class="moment-item"
        >
          <div class="title">{{ item.title }}</div>
          <div class="description">{{ item.description }}</div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { ugcItemTypeMomentUgc } from "@/util/const";
  import { Tag } from "vant";
  
  export default {
    name: "StoryItemList",
    components: {
      Tag
    },
    props: {
      data: {
        type: Array,
        default: () => []
      }
    },
    methods: {
      showDetailItem(item) {
        if (item.type === ugcItemTypeMomentUgc) {
          this.$router.push("/moment_lite/" + item.id);
        }
      }
    },
    computed: {}
  };
  </script>
  
  <style lang="scss" scoped>
  .tab-item-container {
    display: flex;
    flex-direction: column;
    padding: 0 4px;
  
    .item {
    }
  
    .moment-item {
      background-color: white;
      margin: 5px 5px;
      border-radius: 5px;
  
      padding: 8px 12px;
      border-bottom: 1px solid #f2f2f2;
      line-height: 1.5;
  
      .title {
        line-height: 2;
        font-size: 18px;
        color: #333;
        font-weight: bold;
      }
      .description {
        font-size: 12px;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        /*显示3行，超出的用省略号代替*/
        -webkit-box-orient: vertical;
        overflow: hidden;
        color: grey;
      }
    }
  }
  </style>
  